import axios from './ConfiguredAxios';

const ProfilesApi  = {

	lookupSlug: (name) => {
		return axios.get('/admin/profiles/lookupSlug', {
			params: {
				q: name
			}
		});
	},

	lookup: (name) => {
		return axios.get('/admin/profiles/lookup', {
			params: {
				q: name
			}
		});
	},

	deleteTeamPhoto: (photoId) => {
		return axios.delete('/files/delete/ProfileTeam/' + photoId);
	},

	deleteProfilePhoto: (photoId) => {
		return axios.delete('/files/delete/ProfileImage/' + photoId);
	},

	getImageElementHtml(photoId, iterator) {
		let url = '/profiles/profilePhotoFormElement/' + photoId + '/' + iterator;

		return axios.get(url, {
			headers: {
				'Accept': 'text/html'
			}
		});
	},

	/**
	 * Gets associated articles for a profile
	 *
	 * @link https://github.com/World-Architects/WA3/issues/3003
	 * @param profileId
	 */
	getAssociatedArticles: (profileId) => {
		return axios.get('/profiles/articles/' + profileId);
	}
};

export default ProfilesApi;
